module.exports = __webpack_public_path__ + "img/c85578ff9c8190ac8ab8569b0ae100d0.png";